import { Switch as NbSwitch } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

import type { SwitchProps } from './types';

export const Switch = (props: SwitchProps) => <NbSwitch size="md" {...props} />;

export default addWithConfig(Switch);
